export var ProductJourneyPages;
(function (ProductJourneyPages) {
    ProductJourneyPages["PRODUCT_JOURNEY"] = "productJourney";
    ProductJourneyPages["IMPACT_CLAIM_LIST"] = "impactClaims";
    ProductJourneyPages["IMPACT_CLAIM"] = "impactClaim";
    ProductJourneyPages["SITE_CLUSTER_OVERVIEW"] = "siteClusterOverview";
    ProductJourneyPages["DOCUMENTS"] = "documents";
    ProductJourneyPages["BATCH_TRACING"] = "batchTracing";
    ProductJourneyPages["SITE_BATCH_TRACING"] = "siteBatchTracing";
})(ProductJourneyPages || (ProductJourneyPages = {}));
export const geProductPagesPageIndex = (name) => {
    return {
        [ProductJourneyPages.PRODUCT_JOURNEY]: 0,
        [ProductJourneyPages.IMPACT_CLAIM_LIST]: 1,
        [ProductJourneyPages.IMPACT_CLAIM]: 2,
        [ProductJourneyPages.DOCUMENTS]: 3,
    }[name || ProductJourneyPages.PRODUCT_JOURNEY];
};
